// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3qshv","Ratings":"Header_Ratings__cjk-9","Image":"Header_Image__1pTK0"};